import React from "react";

export default function InputTextAreaFloat({
  name,
  label,
  type,
  disabled,
  rows,
  resizable,
  marginBottom,
  value,
  onChange,
  hint,
  error,
  touched,
  onKeyDown,
  floating = false,
  placeholder,
  required = false,
  onBlur
}) {
  return (
    <div className={`input-text ${floating ? "floating-label" : ""}`}>
      <div
        className={`did-floating-label-content ${floating ? "label-bg" : ""}`}
        style={{ marginBottom: marginBottom ? marginBottom + "px" : "27px" }}
      >
        <textarea
          name={name}
          rows={rows}
          className="did-floating-input"
          style={{
            height: "auto",
            resize: `${resizable ? "auto" : "none"}`,
            paddingTop: "7px",
          }}
          type={type}
          placeholder={placeholder || " "}
          value={value}
          onChange={onChange}
          disabled={disabled}
          onKeyDown={onKeyDown}
          onBlur={onBlur}
        />
        <label className="did-floating-label">{label} {required && <span className="asterisk">*</span>}</label>
        <p className="input-hint">{hint}</p>
        {error && touched ? <div className="input-error">{error}</div> : null}
      </div>
    </div>
  );
}
